import gql from 'graphql-tag'
import { BMDialogBuildingFragment } from '@api/fragments'
import { BMDialogBuilding, CreateBuildingInput } from '@api/types'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

type IPayload = {
  createBuilding: {
    building: BMDialogBuilding
  }
}

const mutateHandler = handleFetchResult<IPayload, BMDialogBuilding>({
  handler: (data) => data.createBuilding.building,
  name: 'Building',
})

export default function create(input: CreateBuildingInput) {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation CreateBuilding($input: CreateBuildingInput!) {
    createBuilding(input: $input) {
      building {
        ...BMDialogBuildingFragment
      }
    }
  }
  ${BMDialogBuildingFragment}
`
